const graphToArray = (data) => {
  return data ? data.edges.map((edge) => {
    return edge.node;
  }) : [];
}
export default graphToArray
